import { Inject, Injectable } from '@angular/core';
import { DigitaDataValues, DigitalDataConstants, DigitalDataInfo, DigitalDataQuadrigam } from '@src/app/core/constants/ib-digital-data-constants';
import { CkiDatalayerConstants, CkiDatalayerConstantsType } from '@src/app/shared/services/ib-datalayer/ib-cki-datalayer-constants';
import { AJSDatalayerService, AJSDatalayerServiceType } from '@src/app/shared/services/ib-datalayer/services/ib-cki-datalayer-service-bridge.service';
import { AJSDatalayerUtilsService, AJSDatalayerUtilsServiceType } from '@src/app/shared/services/ib-datalayer/services/ib-cki-datalayer-utils-service-bridge.service';
import { AJSDigitalDataService, AJSDigitalDataServiceType } from '@src/app/shared/services/ib-datalayer/services/ib-cki-digital-data-service-bridge.service';

@Injectable({providedIn: 'root'})
export class IbCheckinApisDigitalDataService {
    constructor (
        @Inject(AJSDigitalDataService) private DigitalDataService: AJSDigitalDataServiceType,
        @Inject(AJSDatalayerUtilsService) private DatalayerUtilsService: AJSDatalayerUtilsServiceType,
        @Inject(AJSDatalayerService) private DatalayerService: AJSDatalayerServiceType
    ) { }

    public emitViewEvent = (): void => {
        this.DigitalDataService.emitViewEvent();
    };

    public addDigitalDataInfo = ( digital_data ): void => {
        this.DigitalDataService.addDigitalDataInfo( digital_data );
    };

    public setApisDigitalData = (): void => {
        this.DatalayerService.setProcessAndStep( DigitalDataQuadrigam.APIS );
    };

    public updateApisDigitalData = (): void => {
        /* INIT DELETE GA4 MIGRATION*/
        const extendedObject = {};
        extendedObject['APIScumplimentados'] = DigitaDataValues.YES;
        this.DatalayerUtilsService.addDataLayerInfo(extendedObject);
        /* FIN DELETE GA4 MIGRATION*/
        const extendedDigitalDataInfo = {};
        extendedDigitalDataInfo[DigitalDataInfo.APIS_COMPLETED] = DigitaDataValues.YES;
        this.DatalayerUtilsService.addDigitalDataInfo(extendedDigitalDataInfo);
    };

    public getDigitalDataProcess = (): string => {
        const digital_data = this.DigitalDataService.getDigitalData();
        if ( digital_data == null ) return;
        return digital_data[ DigitalDataConstants.PROCESS ];
    };

    public setDigitalDataVoucherShown = ( hasVoucher: boolean = false ) => {
        const digital_data = this.DigitalDataService.getDigitalData();
        if ( digital_data == null ) return;
        digital_data[ DigitalDataConstants.VOUCHER_SHOWN ] = hasVoucher ? DigitaDataValues.YES : DigitaDataValues.NO;
        this.DigitalDataService.addDigitalDataInfo( digital_data );
    };

}
